import { render, staticRenderFns } from "./AllOrdersMaterials.vue?vue&type=template&id=3d96d558&scoped=true"
import script from "./AllOrdersMaterials.vue?vue&type=script&lang=js"
export * from "./AllOrdersMaterials.vue?vue&type=script&lang=js"
import style0 from "./AllOrdersMaterials.vue?vue&type=style&index=0&id=3d96d558&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d96d558",
  null
  
)

export default component.exports